document.addEventListener("DOMContentLoaded", function () {
  const countdown_block = document.querySelector(".countdown_block");
   const normal_countdown_block = document.querySelector(".promo_div");
  const main_div_height = document.querySelectorAll(".marqueeSlider .promo_div");

  
  if (countdown_block) {
    const targetHeight = `${countdown_block.offsetHeight}px`;

   
    main_div_height.forEach(div => {
      div.style.height = targetHeight;
    });

    // Alternatively, you could use a standard for loop:
    /*
    for (let i = 0; i < main_div_height.length; i++) {
      main_div_height[i].style.height = targetHeight;
    }
    */
  }
  // else{
  //    const target_Height = `${normal_countdown_block.offsetHeight}px`;

   
  //   main_div_height.forEach(promo_div => {
  //     promo_div.style.height = target_Height;
  //   });
  // }
});

document.addEventListener("DOMContentLoaded", function () {
    const slider__block = document.querySelector(".promo_slider_enable");
    const normal_countdown_blocks = document.querySelectorAll(".promo_div");

    if (slider__block && normal_countdown_blocks.length > 0) {
       
        const target_Height = `${normal_countdown_blocks[0].offsetHeight}px`;

       
        normal_countdown_blocks.forEach(promo_div => {
            promo_div.style.height = target_Height;
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const announcement = document.getElementById("sticky_announcement");
  const header = document.getElementById("header");

  if (!announcement || !header) return; // prevent errors if elements don't exist

  window.addEventListener("scroll", function () {
    if (window.pageYOffset > 0) {
      announcement.classList.add("sticky");
    //   header.classList.add("sticky");
     
     
      header.style.top = `${announcement.offsetHeight}px`;
    } else {
      announcement.classList.remove("sticky");
      header.classList.remove("sticky");
      header.style.top = "0";
    }
  });
});

// Mobile Header
document.addEventListener("DOMContentLoaded", function () {
  const mobile_announcement = document.getElementById("sticky_announcement");
  const mobile_header = document.getElementById("mobile-header");

  if (!mobile_announcement || !mobile_header) return; // prevent errors if elements don't exist

  window.addEventListener("scroll", function () {
    if (window.pageYOffset > 0) {
      mobile_announcement.classList.add("sticky");
    //   header.classList.add("sticky");
      mobile_header.style.top = `${mobile_announcement.offsetHeight}px`;
    } else {
      mobile_announcement.classList.remove("sticky");
      mobile_header.classList.remove("sticky");
      mobile_header.style.top = "0";
    }
  });
});


//  document.addEventListener("DOMContentLoaded", function () {
//   const appAnnouncement = document.getElementById("announcement-bar-with-slider"); // top bar
//   const promoBar = document.getElementById("sticky_announcement"); // second bar
//   const header = document.getElementById("header"); // header

//   if (!appAnnouncement || !promoBar || !header) return; // safety check

//   window.addEventListener("scroll", function () {
//     if (window.pageYOffset > 0) {
//       // Make all sticky
//       appAnnouncement.classList.add("sticky");
//       promoBar.classList.add("sticky");
//       header.classList.add("sticky");

//       // Stack them one after another
//       promoBar.style.top = `${appAnnouncement.offsetHeight}px`;
//       header.style.top = `${appAnnouncement.offsetHeight + promoBar.offsetHeight}px`;
//     } else {
//       // Reset
//       appAnnouncement.classList.remove("sticky");
//       promoBar.classList.remove("sticky");
//       header.classList.remove("sticky");

//       promoBar.style.top = "0";
//       header.style.top = "0";
//     }
//   });
// });
